/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { authToken, StorageKeys } from '../../../../utilities/LocalStorage';
import RouteNames from '../../RouteNames';

import ChangePasswordWithMfa from './ChangePasswordWithMfa';
import { getChangePasswordFlowData } from '../../redux/reduxSelectors';
import { ChangePasswordFlowActions } from '../../redux/userFlowActions';
import NavigationActions from '../../redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const changePasswordFlowData = getChangePasswordFlowData(state);
  const passwordsValid = changePasswordFlowData.currentPasswordIsValid && changePasswordFlowData.newPasswordIsValid;
  return {
    isWaitingForMfa: changePasswordFlowData.passwordSubmitSuccessful && changePasswordFlowData.active,
    submitDisabled: !passwordsValid,
    cancelMfaRoute: RouteNames.changePassword(),
    errorMessage: '',
    mfaCode: changePasswordFlowData.mfaCode,
    mobileNumber: '',
    token: authToken.get(StorageKeys.AUTH_TOKEN),
    goBack: () => {
      NavigationActions.goBackTo(routerProps.history, RouteNames.changePassword());
    },
    finishPasswordChange: () => {
      ChangePasswordFlowActions.reset();
      NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submitMfaCode: ChangePasswordFlowActions.submitPasswordsWithMfa,
    onChangeMfaCode: ChangePasswordFlowActions.mfaCode,
    clearPassword: ChangePasswordFlowActions.undoSubmitPassword,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordWithMfa);
